/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEmail24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.25 18.25V13.3a.3.3 0 01.3-.3h.9a.3.3 0 01.3.3v4.95c0 .28.105.54.277.725.17.183.391.275.61.275h14.727a.835.835 0 00.609-.275c.172-.184.277-.444.277-.725V13.3a.3.3 0 01.3-.3h.9a.3.3 0 01.3.3v4.95c0 .647-.24 1.278-.681 1.75a2.334 2.334 0 01-1.705.75H4.636c-.65 0-1.261-.276-1.705-.75a2.563 2.563 0 01-.681-1.75z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2.949 4.949a2.386 2.386 0 011.687-.699h14.728a2.387 2.387 0 012.386 2.386v2.722a.3.3 0 01-.156.263l-9.45 5.155a.3.3 0 01-.288 0l-9.45-5.155a.3.3 0 01-.156-.263V6.636c0-.633.251-1.24.699-1.687zm1.687.801a.886.886 0 00-.886.886v1.832c0 .11.06.21.156.263l7.95 4.336a.3.3 0 00.288 0l7.95-4.336a.3.3 0 00.156-.263V6.636a.886.886 0 00-.886-.886H4.636z'
      />
    </svg>
  );
}

export default SvgEmail24;
